import React from 'react'

export const site = {
  name: 'En Requiem',
  game: 'Requiem RPG',
  logo: '/codex/assets/enr/enreq-logo.svg',
  copyright: <>Requiem RPG &trade; En Requiem &trade; and &copy; 1998 -</>
}
